/* this file is transformed by vux-loader */
/* eslint-disable */
import TpLoadingBar from './index';

var install = function install(Vue, options) {
  // 1. 添加全局方法或属性
  Vue.prototype.$tpLoadingTar = TpLoadingBar;
};

export default {
  install: install,
  TpLoadingBar: TpLoadingBar
};